// Bootstrap
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Link } from "react-router-dom";
import ListGroup from 'react-bootstrap/ListGroup';
// Libs
import { TwitterShareButton } from 'react-twitter-embed';

const Invest = () => {
  return (
    <>
      <Row className="justify-content-md-center text-center" style={{marginTop: "48px"}}>
        <Col md="5">
        <span style={{fontSize: "3rem"}}>🏋️‍♂️</span>
          <h1 style={{fontSize: "2rem"}}>Want to join as a builder?</h1>
          <p>dm me on twitter: <a target="_blank" href="https://twitter.com/0xconstantin">0xconstantin</a></p>
          <p>you apply with a pitchdeck</p>
          <p>community votes</p>
          <p>we let you know if you're in or not</p>
        </Col>
      </Row>
      <Row className="justify-content-md-center text-center" style={{marginTop: "48px"}}>
        <Col md="5">
          <span style={{fontSize: "3rem"}}>🥷</span>
          <h1 style={{fontSize: "2rem"}}>Want to join as talent?</h1>
          <p>dm me on twitter: <a target="_blank" href="https://twitter.com/0xconstantin">0xconstantin</a></p>
          <p>talent members work closely with our builders</p>
          <p>paid, donation and/or barter deals</p>
        </Col>
      </Row>
      <Row className="justify-content-md-center text-center" style={{marginTop: "48px"}}>
        <Col md="5">
          <span style={{fontSize: "3rem"}}>🧝</span>
          <h1 style={{fontSize: "2rem"}}>Want to join as a mentor?</h1>
          <p></p>
          <p>dm me on twitter: <a target="_blank" href="https://twitter.com/0xconstantin">0xconstantin</a></p>
          <p>we're seeking mentors with experience in:</p>
          <p>engineering, audience building, regulations</p>
        </Col>
      </Row>
      <Row className="justify-content-md-center text-center" style={{marginTop: "48px"}}>
        <Col md="5">
          <span style={{fontSize: "3rem"}}>🌱</span>
          <h1 style={{fontSize: "2rem"}}>Want to join as an investor?</h1>
          <p></p>
          <p>dm me on twitter: <a target="_blank" href="https://twitter.com/0xconstantin">0xconstantin</a> or</p>
          <p>reach out to our <Link to="/ventures">venture builders</Link> directly</p>
        </Col>
      </Row>
      <Row className="justify-content-md-center text-center" style={{marginTop: "48px"}}></Row>
    </>
  );
};

export default Invest;
